import React from 'react';
import EImg from './EImg';

const EVic = ({ width = 24, height = 24 }) => (
	<EImg
		width={width}
		height={height}
		title="Boo-yeah!"
		aria-label="Emoji: Victory hand"
		alt="✌️"
		src="https://abs.twimg.com/emoji/v2/72x72/270c.png"
	/>
);

export default EVic;
